import { AuthManager } from "features/Authentication/AuthManager"
import { processAuthCode } from "features/Authentication/processAuthCode"
import { useGlobalContext } from "global/Context/context"
import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { readShadowFromSearchParams, SHADOW_SEARCH_PARAM } from "utils/shadow"

const useAuthCodeProcessor = (options = { shouldRedirectToLogin: true }) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const authCode = searchParams.get("code")
  const shadow = readShadowFromSearchParams(searchParams)

  const { isAuthenticated, setAuthInfo } = useGlobalContext()

  useEffect(() => {
    if (authCode) {
      processAuthCode(authCode, undefined, shadow).then(auth => {
        if (auth) {
          setAuthInfo(auth)
        }
        searchParams.delete("code")
        searchParams.delete(SHADOW_SEARCH_PARAM)
        setSearchParams(searchParams, { replace: true })
      })
      return
    }

    if (!isAuthenticated && options.shouldRedirectToLogin) {
      AuthManager.redirectToLogin()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, authCode])
}

export default useAuthCodeProcessor
